import gql from 'graphql-tag';

export const getEstadisticasLlavesGql = gql`
    query data ($fecha: Date!) {
        estadisticasLlaves(fecha:$fecha){
            totalLlavesActivas
            nuevasLlavesMes
            promedioLlavesPorCliente
        }
    }
`;

export const getLlavesAnuladasMesGql = gql`
    query data ($anio: Int!, $mes: Int!) {
        llavesAnuladasMes(anio:$anio, mes:$mes){
            ruc
            razonsocial
            documento
            codactivacion
            producto
            fechaExpiracion
        }
    }
`;

export const getLlavesPorExpirarGql = gql`
    query data {
        llavesPorExpirar{
            ruc
            razonsocial
            documento
            codactivacion
            producto
            fechaExpiracion
        }
    }
`;

export const getEstadoLlavesAnualGql = gql`
    query data ($fecha: Date!, $codProducto: String) {
        estadoLlavesAnual(fecha:$fecha, codProducto:$codProducto){
            estado
            mes
            producto
            value
        }
    }
`;

export const getResumenLlavesGql = gql`
    query data ($fecha: Date!) {
        resumenLlaves(fecha:$fecha){
            ruc
            razonsocial
            producto
            usuario
            mes
            value
        }
    }
`;